import { Text, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import {
  ButtonSkeleton,
  ColoredSkeleton,
  DetailsSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import { privatePensionTableHead } from '../constants';

export const ListLoadingItemTablet: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const bottomInfos = [
    {
      label: privatePensionTableHead[2].title,
      value: <TextSkeleton />,
    },
    {
      label: privatePensionTableHead[3].title,
      value: <TextSkeleton />,
    },
    {
      label: privatePensionTableHead[4].title,
      value: <TextSkeleton />,
    },
  ];

  const bottomInfos2 = [
    {
      label: privatePensionTableHead[5].title,
      value: <TextSkeleton />,
    },
    {
      label: privatePensionTableHead[6].title,
      value: (
        <HStack space="stack.quarck">
          <DetailsSkeleton />
          <TextSkeleton />
        </HStack>
      ),
    },
    {
      label: privatePensionTableHead[7].title,
      value: (
        <HStack space="stack.quarck">
          <DetailsSkeleton />
          <TextSkeleton />
        </HStack>
      ),
    },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <HStack space="inline.quarck" alignItems="center" justifyContent="space-between">
          <TextSkeleton />
          <HStack space="inline.quarck" alignItems="center">
            <ColoredSkeleton width={140} height={50} borderRadius={BoxRadius.lg} />
            <DetailsSkeleton />
          </HStack>
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos.map(({ label, value }) => (
            <VStack maxWidth="24%" minWidth="24%" space="stack.quarck" key={label}>
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
          <Stack alignSelf="flex-end" maxWidth="15%" minWidth="15%"></Stack>
        </HStack>
        <HStack justifyContent="space-between">
          {bottomInfos2.map(({ label, value }) => (
            <VStack maxWidth="24%" minWidth="24%" space="stack.quarck" key={label}>
              <Text color="neutral.black" variant="semibold">
                {label}
              </Text>
              {value}
            </VStack>
          ))}
          <Stack alignSelf="flex-end" maxWidth="15%" minWidth="15%">
            <ButtonSkeleton />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
